/** Copyright-linje der vises i bunden af alle sider og i login-boksen. */
export const COPYRIGHT_TEXT = `© ${new Date().getFullYear()} Sk-system.dk — Alle rettigheder forbeholdes.`

export function Footer({ className = 'footer' }: { className?: string }) {
  return <footer className={className}>{COPYRIGHT_TEXT}</footer>
}
